import React from 'react';
import styled from 'styled-components';
import selectIllustration from './select_illustration.svg';

const StyledWrapper = styled.div`
  display: flex;
`;

const StyledContent = styled.div`
  margin-left: ${props => props.theme.spacing[2]};
  width: 60%;
`;

const SelectDescription = () => (
  <StyledWrapper>
    <div>
      <img src={selectIllustration} alt="Direct job" />
    </div>
    <StyledContent>
      <h6>Select</h6>
      <p>Multiple Weployees can express interest in your role. Weploy will create a shortlist for you to make a selection within 24 hours.</p>
      <p>
        Browse between experienced candidates<br />
        Remove bias, focus on what matters<br />
        Choose from a live shortlist
      </p>
    </StyledContent>
  </StyledWrapper>
);

export default SelectDescription;
